import Guide from './'

/*
 * Used when we're snapping but not showing the user a visual guide
 */
const HiddenSnap = Guide.extend({

  el: '',

  set: () => {}

})

const VerticalHidden = HiddenSnap.extend({

  type: 'vertical',

  direction: 'left'

})

const HorizontalHidden = HiddenSnap.extend({

  type: 'horizontal',

  direction: 'top'

})

export const Horizontal = HorizontalHidden
export const Vertical = VerticalHidden
